<ion-content>
  <div class="email-bg-grid">
    <div class="company-logo-sec">
      <img src="assets/images/bizdata-header-logo.png">
    </div>
    <div class="email-bg-content">
      <span class="content-1"> Thanks for Signup with</span>
      <span class="content-log-header"> Bizdata Family</span>
      <div class="email-body">
        <span class="header">Hi UserName</span>
        <div class="body">Congradulations on starting integrated data anylytics journey with us.</div>
      </div>
    </div>
  </div>
  <div class="section-1">
    <div class="views-content">
      <span class="content">Click below to verify account</span>
      <div class="btn-verify-grid">
        <button mat-raised-button class="btn-verify">Verify Account</button>
      </div>
      <span class="content">To easily log in later, save this URL:</span>
      <div class="userName-section">
        <span>Username:</span>
        <span>test@ezintegration.com</span>
      </div>
      <span class="content">Again welcome to Bizdata family</span>
    </div>
  </div>
  <div class="section-2">
    <div class="views-content">
      <span>Bizdata Inc is a SaaS based company making data integration and anylatics eaiser and affordable than even through our AI-powered no-code platforms</span>
    </div>
  </div>
  <div class="section-3">
    <div class="views-content">
      <div class="main-logo-sec">
        <img src="assets/images/eZintegration-black-logo.svg">
      </div>
      <span>No-code cloud based iPaas to connect enterprises</span>
    </div>
  </div>
  <div class="section-3">
    <div class="views-content">
      <div class="main-logo-sec">
        <img src="assets/images/bizintel360-log.png">
      </div>
      <span>Self service no-code advanced anylaticsand data visualization to simplify data.</span>
    </div>
  </div>
  <div class="section-4">
      <div class="btn-learn-more-grid">
        <button mat-raised-button class="btn-learn-more">Learn More</button>
      </div>
  </div>
  <div class="section-5">
    <div class="contact-section-1">
      <span>Get in touch</span>
      <span>+1-650-283-1644</span>
    </div>
    <div class="contact-section-2">
      <span>Email : info@bizdata360.com</span>
      <span>web : www.bizdata360.com</span>
    </div>
    <div class="contact-section-3">

    </div>
  </div>
  <app-footer></app-footer>
</ion-content>